import React, { useEffect, useState } from 'react';  
import { Link } from 'react-router-dom';  
//@ts-ignore  
import fullLogo from '../../assets/logo/ByteSplash_Logo.png';  
//@ts-ignore  
import logoOnly from '../../assets/logo/Logo_only.png';  
import './logo.css';  

interface LogoProps {  
  className?: string;  
  sidebarOpen?: boolean;  
}  

const Logo: React.FC<LogoProps> = ({ className = '', sidebarOpen = false }) => {  
  const [isVisible, setIsVisible] = useState(false); // State to manage visibility  

  useEffect(() => {  
    const checkUserLoggedIn = async () => {  
      // Check local storage for user data  
      const userData = JSON.parse(localStorage.getItem('user') || 'null');  

      // Set visibility based on logged-in status  
      if (userData && userData.accessToken) {  
        setIsVisible(true);  
      } else {  
        setIsVisible(false);  
      }  
    };  

    checkUserLoggedIn();  
  }, []); // Run only once, when the component mounts  

  if (!isVisible) return null; // Return null if not visible  

  return (  
    <Link to="/" className={`flex items-center gap-2 ${className}`}>  
      {!sidebarOpen ? (  
        <img src={logoOnly} className="animate-spin-slow" height={40} width={40} alt="Logo Only" />  
      ) : (  
        <img src={fullLogo} height={40} width={200} alt="Full Logo" />  
      )}  
    </Link>  
  );  
};  

export default Logo;  